import { useMutation } from '@tanstack/react-query';
import { apiUpload } from './client';

export interface AdminUploadResult {
  id: string;
  /** Absolute URL the form should save into the entity's `imageUrl` field. */
  url: string;
  category: string;
  mimeType: string;
  sizeBytes: number;
}

/**
 * Mutation hook for uploading a single file via multipart to
 * `POST /admin/uploads`. The `category` label groups uploads in the DB —
 * useful for future per-bucket admin views (e.g. "all programme covers").
 */
export function useAdminUpload(category = 'general') {
  return useMutation({
    mutationFn: (file: File) =>
      apiUpload<AdminUploadResult>('/admin/uploads', file, { category }),
  });
}
